import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, TabsContainer } from 'react-md';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router';

import { invokeBackendApi } from '../libs/awsLib';
import DriverSelection from './DriverSelection';
import Contested from './Contested';

import JourneyDialog from './Journey';


export default withRouter(injectIntl(class PsyMain extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    activeTabIndex: PropTypes.number,
    history: PropTypes.object.isRequired,
    userAttributes: PropTypes.shape({
      isPsy: PropTypes.bool.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: props.activeTabIndex || 0,
      isLoading: true,
      segmentsByDriver: [],
      dashboard: {},
      journeyIndex: undefined,
    };
  }

  componentDidMount() {
    this.loadSegments();
    this.loadDashboard();
  }

  segmentsByDriver = () => invokeBackendApi({ path: '/errors' })
  dashboard = () => invokeBackendApi({ path: '/dashboard' })

  loadSegments = () => {
    this.segmentsByDriver()
      .then(segmentsByDriver => this.setState({ isLoading: false, segmentsByDriver }))
      .catch(e => alert(e));
  }

  loadDashboard = () => {
    this.dashboard()
      .then((dashboardLoaded) => {
        const dashboard = dashboardLoaded.reduce((acc, elt) => ({ ...acc, [elt.driverId]: elt }), {});
        return this.setState({ isLoading: false, dashboard });
      })
      .catch(e => alert(e));
  }

  handleClickContested = (segment) => {
    this.setState({
      journeys: [{ journeyId: segment.journeyId }],
      journeyIndex: 0,
      driverId: segment.driverId,
    });
  }

  render() {
    const {
      segmentsByDriver, dashboard, journeyIndex, journeys, driverId,
    } = this.state;
    const { intl, userAttributes, ...childProps } = this.props;

    return (
      <div>
        <TabsContainer>
          <Tabs
            tabId="users-tabs"
          >
            <Tab label={intl.formatMessage({ id: 'menu.title.driversShort' })} >
              <DriverSelection {...childProps} segmentsByDriver={segmentsByDriver} dashboard={dashboard} />
            </Tab>
            <Tab label={intl.formatMessage({ id: 'menu.title.contested' })} >
              <Contested
                handleOnclick={this.handleClickContested}
                userAttributes={userAttributes}
                segmentsByDriver={segmentsByDriver}
              />
            </Tab>
          </Tabs>
        </TabsContainer>
        <JourneyDialog
          journeys={journeys}
          initialJourneyIndex={journeyIndex}
          onHide={() => this.setState({ journeyIndex: undefined })}
          userAttributes={userAttributes}
          driverId={driverId}
        />
      </div>
    );
  }
}));



// WEBPACK FOOTER //
// ./src/components/PsyMain.js